import React from 'react'

interface ExportIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Export icon component for downloading/exporting data
 */
const ExportIcon: React.FC<ExportIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M12 10V12H3.99996V10H2.66663V12C2.66663 12.7333 3.26663 13.3333 3.99996 13.3333H12C12.7333 13.3333 13.3333 12.7333 13.3333 12V10H12ZM11.3333 7.33334L10.3933 6.39334L8.66663 8.11334V2.66667H7.33329V8.11334L5.60663 6.39334L4.66663 7.33334L7.99996 10.6667L11.3333 7.33334Z'
        fill={color}
      />
    </svg>
  )
}

export default ExportIcon
